module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/agent-valuation-317c2ac9802ebbd17e19d7c008ad5d56.svg";